import React from 'react';
import { DISCOUNT, PRICE, PRODUCT_MOCKUP, SAVINGS, TOTAL_VALUE, offerGuarantees, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-174" data-mp="1mnsecntgiydt">
      <div className="mx-auto max-w-md" data-id="element-175" data-mp="1hopi9svgg2hz">
        <div className="text-center" data-id="element-176" data-mp="1hpqrdrswuex2">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-177" data-mp="1hqs6c7d1rlk2">
            Limitiertes Angebot
          </span>
          <h2 className="mt-4 font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-178" data-mp="p0jx550hobhm">
            Spezielles Launch-Angebot
          </h2>
        </div>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-179" data-mp="yxok3725sazh">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-180" data-mp="2fb4zqunvt05j">
            MATHE BEREIT™ Paket
          </span>

          <img src={PRODUCT_MOCKUP} alt="MATHE BEREIT™ Paket mit 6 kompletten Bänden" className="mx-auto w-40 drop-shadow-[0_16px_22px_rgba(20,17,15,0.22)]" data-id="element-181" data-mp="pmbfxskd704g" />

          <dl className="mt-4" data-id="element-182" data-mp="zgk7oe1kmp1k">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-183" data-mp="13jgktp8cdsy4">
                <dt className="text-ink/80" data-id="element-184" data-mp="bs0wnqr4zy5s">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-185" data-mp="bqg8civf1bgd">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-186" data-mp="kl48jum4w2yb">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-187" data-mp="3k8lzept6dv0g">Gesamtwert</dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-188" data-mp="3k6t3o5k3ov78">{TOTAL_VALUE}</dd>
            </div>
          </dl>

          <div className="border-b border-ink/10 pb-7 pt-7 text-center" data-id="element-189" data-mp="vfh4q7ui0tjc">
            <p className="flex items-baseline justify-center gap-2 whitespace-nowrap" data-id="element-190" data-mp="vdnvqlwexx86">
              <span className="font-display text-[3.4rem] font-black leading-none text-brand sm:text-7xl" data-id="element-191" data-mp="qge18ru62vdh">
                {PRICE}
              </span>
              <span className="text-sm font-bold text-ink/50" data-id="element-192" data-mp="105xm231fwzaz">EUR</span>
            </p>
            <p className="mt-4 inline-block rounded-full bg-brand-light px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-brand-dark" data-id="element-193" data-mp="cgmo0tbh5j0j">
              Du sparst {SAVINGS} ({DISCOUNT})
            </p>
          </div>

          <CtaButton className="mt-6 w-full" data-id="element-194" data-mp="liche4ox2s0y" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-195" data-mp="hfzc1he30w4p">
            {offerGuarantees.join(' · ')}
          </p>
        </div>
      </div>
    </section>;
}